import { API } from "config/api";
import { API_ROUTES } from "config/apiRoutes";

export type EducationRecordAccessLogEntry = {
  education_record_access_log_id: string;
  actor_user_id: string;
  actor_role: string;
  org_id: string | null;
  subject_user_id: string | null;
  resource_type: string;
  resource_id: string | null;
  action: string;
  reason: string | null;
  ip_address: string | null;
  user_agent: string | null;
  created_at: string;
  actor?: { user_id: string; name: string; email: string } | null;
  subject?: { user_id: string; name: string; email: string } | null;
  organization?: { org_id: string; name: string } | null;
};

export type EducationRecordAccessLogResponse = {
  entries: EducationRecordAccessLogEntry[];
  total: number;
};

export type EducationRecordResourceType =
  | "feedback"
  | "student_feedback_list"
  | "student_overview"
  | "struggling_learner_roster"
  | "struggling_learner";

/**
 * Reports a read of identifiable student records so the FERPA audit trail
 * covers data the browser loads straight from Hasura. Never blocks the UI: the
 * API validates access and ignores self-access.
 */
export function recordEducationRecordRead(params: {
  resourceType: EducationRecordResourceType;
  resourceId: string;
  reason?: string;
}): void {
  void API.post(API_ROUTES.EDUCATION_RECORD_ACCESS_LOG.RECORD(), params, {
    preserveSessionOnUnauthorized: true,
  }).catch(() => undefined);
}

export async function listEducationRecordAccessLog(params?: {
  orgId?: string;
  q?: string;
  action?: string;
  limit?: number;
  offset?: number;
}): Promise<EducationRecordAccessLogResponse> {
  const { data } = await API.get<EducationRecordAccessLogResponse>(
    API_ROUTES.EDUCATION_RECORD_ACCESS_LOG.LIST(params),
  );
  return {
    entries: data.entries || [],
    total: data.total ?? 0,
  };
}
